import { render, staticRenderFns } from "./AddWheatIssueModal.vue?vue&type=template&id=1dd5b689&"
import script from "./AddWheatIssueModal.vue?vue&type=script&lang=js&"
export * from "./AddWheatIssueModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports